import Typography from "@portal/components/atoms/v2/typography";
import { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "@portal/redux/store";
import { useRouter } from "next/navigation";
import { MainBox } from "../components/mainBox";
import { UserMessageComponent } from "../components/message/UserMessageComponent";
import { IPageProps } from "@portal/types/robot/IPageProps";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { InfoBoxComponent } from "@portal/components/atoms/infoBox";
import { SelectionBoxComponent } from "../components/selectionBox/SelectionBoxComponent";
import { setMoreValuesThanDebt } from "@portal/redux/reducers/riskLevelReducer";
import { TextLine } from "@portal/components/atoms/v2/textLine";
import Button from "@portal/components/atoms/v2/buttons/button";
import { OnFooterClick } from "./handlers/OnFooterClick";
import { useSession } from "@portal/auth/client/SessionProvider";
import Checkbox from "@portal/components/atoms/v2/checkbox";

export const DebtPage = ({ centerId, pageIndex, isDefaultLanguage }: IPageProps) => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { session } = useSession();
  const { request } = useAppSelector(state => state.persisted.riskLevel);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [showUserMessage, setShowUserMessage] = useState(false);
  const [selectedOption, setSelectedOption] = useState<number | null>(SetInitialValue(request.moreValuesThanDebt));

  const isButtonDisabled =
    selectedOption === null || selectedOption === 0 || request.moreValuesThanDebt === null || !checkboxChecked;

  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_11_A, texts.PAGE_11_B];
  const isLoggedIn = session?.status !== "unauthenticated";
  const redirect = !isLoggedIn && !isButtonDisabled;

  const OnSelectionClick = (selectedOption: number) => {
    setSelectedOption(selectedOption);
    if (selectedOption !== null) dispatch(setMoreValuesThanDebt(selectedOption === 1));
  };

  useEffect(() => {
    if (selectedOption === 0) {
      setShowUserMessage(true);
    }
  }, [selectedOption]);

  const OnCheckboxClick = useCallback(() => {
    setCheckboxChecked(!checkboxChecked);
  }, [checkboxChecked]);

  return (
    <>
      <MainBox>
        <Typography variant="H6">{texts.PAGE_11_SUBHEADER}</Typography>
        <TextLine />
        <SelectionBoxComponent options={options} selectedOption={selectedOption} onSelectionClick={OnSelectionClick} />
        <Typography variant="Body">{texts.PAGE_11_INFO}</Typography>
        <div className="flex mt-4">
          <Checkbox
            id="confirm"
            text={texts.PAGE_11_CONFIRM}
            isChecked={checkboxChecked}
            onChange={OnCheckboxClick}
            largeTextOnly
          />
        </div>
        {redirect && <InfoBoxComponent texts={[texts.PAGE_11_REDIRECT]} />}
      </MainBox>
      {showUserMessage && (
        <UserMessageComponent
          userMessage={texts.MESSAGE_CREDIT}
          showDialog={showUserMessage}
          secondaryButtonText={texts.MESSAGE_CHANGE_REPLY}
          secondaryButtonClick={() => {
            setShowUserMessage(false);
            setSelectedOption(null);
          }}
        />
      )}
      <div className="flex w-full p-5 justify-between">
        <Button onClick={() => OnFooterClick(centerId, pageIndex, router, isLoggedIn)} text={texts.BUTTON_BACK} />
        <Button
          onClick={() => OnFooterClick(centerId, pageIndex, router, isLoggedIn, true)}
          text={isLoggedIn ? texts.BUTTON_NEXT : texts.BUTTON_LOG_IN}
          disabled={isButtonDisabled}
          wide={!isLoggedIn}
          primary
        />
      </div>
    </>
  );
};

function SetInitialValue(selectedOption: boolean | null) {
  if (selectedOption === null) return null;
  return selectedOption ? 1 : 0;
}
